import React from 'react';
import { WidgetSize } from '../../widget.types';
import { configureModalMap } from '@topconagriculture/modal';
import { DeviationWidgetXS } from './DeviationWidgetXS';
import { DeviationWidgetS } from './DeviationWidgetS/DeviationWidgetS';
import { DeviationWidgetL } from './DeviationWidgetL/DeviationWidgetL';
import { makeStyles } from '@material-ui/core/styles';
import { DeviationWidgetLModal } from './modals/DeviationWidgetLModal';
import { DeviationChartModal } from './modals/DeviationChartModal/DeviationChartModal';
const deviationWidgetSizeMap = {
    [WidgetSize.XS]: DeviationWidgetXS,
    [WidgetSize.S]: DeviationWidgetS,
    [WidgetSize.L]: DeviationWidgetL,
};
export const deviationGeneralAlertsModalName = '@@widget/deviation/general/alerts';
export const itemDeviationAlertsModalName = '@@widget/deviation/item/alerts';
configureModalMap({
    [deviationGeneralAlertsModalName]: React.createElement(DeviationWidgetLModal, null),
    [itemDeviationAlertsModalName]: React.createElement(DeviationChartModal, null),
});
const useStyles = makeStyles(() => ({
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        overflow: 'hidden',
    },
}));
export const DeviationWidget = ({ widget }) => {
    var _a;
    const classes = useStyles();
    const Component = deviationWidgetSizeMap[((_a = widget.config) === null || _a === void 0 ? void 0 : _a.size) || WidgetSize.XS];
    const link = '/reports/specific/loadreport';
    return React.createElement("div", { className: classes.contentContainer }, Component ? React.createElement(Component, { link: link, widget: widget }) : null);
};
//# sourceMappingURL=DeviationWidget.js.map